import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';

import {
  CircularProgress,
  Grid,
  Typography,
} from '@material-ui/core';
import EndIcon from '@material-ui/icons/Lens';
import Masonry from 'react-masonry-component';

import Alert from '../../common/components/Alert';
import MainLayout from '../../common/components/MainLayout';
import AlbumListItem from '../components/AlbumListItem';

import * as mainActions from '../actions';
import classes from '../../css/getCSS';


class Gallery extends Component {
  componentDidMount() {
    document.title = 'Photo Gallery';
    window.scrollTo(0, 0);
    this.props.deepUnmount();
    this.props.getAlbums(this.props.site.id);
  }

  componentWillUnmount() {
    this.props.deepUnmount();
  }

  render() {
    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center">
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let list = null;
    if (this.props.albumsList.length > 0) {
      list = this.props.albumsList.map((item) => {
        return (
          <div className={classes.homeMasonryItem} key={item.id}>
            <AlbumListItem {...item} />
          </div>
        );
      });
    }

    let listEnd = null;
    if (!this.props.next && this.props.count > 0) {
      listEnd = (
        <div align="center" style={{ marginTop: '20px' }}>
          <EndIcon className={classes.endIcon} />
        </div>
      );
    }

    let rootClass = null;
    if (this.props.token) {
      rootClass = classes.dashboardLayout;
    }

    const masonryOptions = {
      transitionDuration: 0,
    };

    return (
      <MainLayout rootClass={rootClass} isAuthenticated={this.props.token !== null}>
        <Grid container spacing={16} justify="center">
          <Grid item md={6} sm={6} xs={12}>
            <Typography variant="display1">Photo Gallery</Typography>
            <span className={classes.titleUnderline} />
            {loading}
            {errorAlert}
            <Masonry options={masonryOptions}>
              {list}
            </Masonry>
            {listEnd}
          </Grid>
        </Grid>
      </MainLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    token: state.auth.token,
    loading: state.main.loading,
    error: state.main.error,
    albumsList: state.main.albumsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.onUnmount()),
    deepUnmount: () => dispatch(mainActions.deepUnmount()),
    getAlbums: () => dispatch(mainActions.getAlbums()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Gallery));



// WEBPACK FOOTER //
// ./src/main/containers/Gallery.js